import * as THREE from 'three';
import { stylize } from '../../Style.js';

export { Scene } from './Scene.js';
export { Tank } from './Tank.js';
export { Airplane } from './Airplane.js';
export { Player } from './Player.js';
export { Sniper } from './Sniper.js';
export { RocketLauncher } from './RocketLauncher.js';
export { Turret } from './Turret.js';
export { Barracks } from './Barracks.js';
export { BuyZone } from './BuyZone.js';
export { HealthPack } from './HealthPack.js';
export { Projectile } from './Projectile.js';
export { Explosion } from './Explosion.js';
export { Obstacle } from './Obstacle.js';

// Low-poly medieval fantasy: stone, timber, wyverns and a day/night cycle
export const id = 'historical';
export const icon = '🏰';
export const name = 'Historical';

export function configureRenderer(renderer) {
  // Filmic tone mapping gives the warm, soft highlights of the stylised look
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.0;
  renderer.setClearColor(0xcfdde3);
}

// Called on every entity's root object after it is built
export function prepare(object) {
  stylize(object);
}

export const strings = {
  subtitle: 'Real-time 3D fantasy strategy',
  about: 'Arena Game is a real-time 3D multiplayer strategy game where two players battle for supremacy using mounted knights, wyverns, dragons, and ballista towers.',
  units: {
    tank: 'Lancer',
    airplane: 'Wyvern',
    super_tank: 'Paladin',
    super_helicopter: 'Dragon',
    sniper: 'Longbow Ranger',
    rocket_launcher: 'Trebuchet'
  },
  iconTank: '🐎',
  iconHelicopter: '🐉',
  tanks: 'Lancers',
  helicopters: 'Wyverns & Dragons',
  money: amount => `🪙 ${amount}`,
  notEnoughMoney: 'Not enough gold',
  buy: 'hire',
  waitingToSpawn: 'mustering...',
  forwardBase: 'Outpost',
  turret: 'Ballista Tower',
  barracks: 'Guardhouse',
  shoot: 'Loose bolt',
  buyClaim: 'Hire/Claim',
  bulkBuy: 'Hire a warband (10 units)',
  bulkBuyShort: 'Warband (10)',
  statTanks: 'Lancers',
  statHelicopters: 'Wyverns',
  statSnipers: 'Rangers',
  statRockets: 'Trebuchets',
  statTurrets: 'Ballista Towers',
  statBarracks: 'Guardhouses',
  statPlayer: 'Knight'
};

// Rewording of the server's plain messages
export const messages = [
  [/Tank captured enemy base/g, 'Lancer breached the enemy keep'],
  [/Need \$(\d+)/g, 'Need $1 gold'],
  [/money/g, 'gold'],
  [/Bulk purchase only available for tanks and helicopters/g, 'Warbands are only available for lancers and wyverns'],
  [/Super Tank/g, 'Paladin'],
  [/Super Helicopter/g, 'Dragon'],
  [/buy zone/g, 'rune circle'],
  [/purchase/g, 'hire units'],
  [/enemy turret/g, 'the enemy ballista tower'],
  [/Turret/g, 'Ballista tower'],
  [/turret/g, 'ballista tower'],
  [/ a base/g, ' an outpost'],
  [/base/g, 'outpost'],
  [/Barracks/g, 'Guardhouse'],
  [/barracks/g, 'guardhouse']
];
